import {ValueObject} from '@s-ui/domain'

export class UnreadMessagesValueObject extends ValueObject {
  #unreadMessages

  constructor({unreadMessages}) {
    super()
    this.#unreadMessages = unreadMessages
  }

  static create({unreadMessages}) {
    return new UnreadMessagesValueObject({unreadMessages})
  }

  toJSON() {
    return {
      unreadMessages: this.#unreadMessages
    }
  }
}
